// Reference: The `selectOnboardingOrderSteps` computed property in the Onboarding Packet is responsible for providing the complete sequence of step orders.
// In this computed, the Ownership step is dynamically added as step 8 by replacing the Integrations step. Review it to understand how the information is delivered.

export default [
  {
    title: 'Classifications',
    step: 0,
    subStep: 1,
    subStepTotal: 1,
    identifier: 'Classifications',
    stage: 'Identity',
  },
  {
    title: 'Identity',
    step: 1,
    subStep: 1,
    subStepTotal: 4,
    identifier: 'Identity-1',
    stage: 'Identity',
  },
  {
    title: 'Identity',
    step: 1,
    subStep: 2,
    subStepTotal: 4,
    identifier: 'Identity-2',
    stage: 'Identity',
  },
  {
    title: 'Identity',
    step: 1,
    subStep: 3,
    subStepTotal: 4,
    identifier: 'Identity-3',
    stage: 'Identity',
  },
  {
    title: 'Identity',
    step: 1,
    subStep: 4,
    subStepTotal: 4,
    identifier: 'Identity-4',
    stage: 'Identity',
  },
  {
    title: 'Operations',
    step: 2,
    subStep: 1,
    subStepTotal: 1,
    identifier: 'Operations',
    stage: 'Operations',
  },
  {
    title: 'Lanes',
    step: 3,
    subStep: 1,
    subStepTotal: 1,
    identifier: 'Lanes',
    stage: 'Lanes',
  },
  {
    title: 'Certifications',
    step: 4,
    subStep: 1,
    subStepTotal: 2,
    identifier: 'Certifications-1',
    stage: 'Certifications',
  },
  {
    title: 'Certifications',
    step: 4,
    subStep: 2,
    subStepTotal: 2,
    identifier: 'Certifications-2',
    stage: 'Certifications',
  },
  {
    title: 'Auto Liability',
    step: 5,
    subStep: 1,
    subStepTotal: 4,
    identifier: 'Insurance-1',
    stage: 'Insurance',
  },
  {
    title: 'Cargo',
    step: 5,
    subStep: 2,
    subStepTotal: 4,
    identifier: 'Insurance-2',
    stage: 'Insurance',
  },
  {
    title: 'Cargo',
    step: 5,
    subStep: 3,
    subStepTotal: 4,
    identifier: 'Insurance-3',
    stage: 'InsuranceExclusions',
  },
  {
    title: "Workers' Compensation",
    step: 5,
    subStep: 4,
    subStepTotal: 4,
    identifier: 'Insurance-4',
    stage: 'Insurance',
  },
  {
    title: 'Payment',
    step: 6,
    subStep: 1,
    subStepTotal: 2,
    identifier: 'Payment-1',
    stage: 'Payment',
  },
  {
    title: 'Payment',
    step: 6,
    subStep: 2,
    subStepTotal: 3,
    identifier: 'Payment-2',
    stage: 'Payment',
  },
  {
    title: 'Payment',
    step: 6,
    subStep: 3,
    subStepTotal: 3,
    identifier: 'Payment-3',
    stage: 'Payment',
  },
  {
    title: 'Payment',
    step: 6,
    subStep: 2,
    subStepTotal: 2,
    identifier: 'Payment-4',
    stage: 'Payment',
  },
  {
    title: 'Payment',
    step: 6,
    subStep: 2,
    subStepTotal: 2,
    identifier: 'Payment-5',
    stage: 'Payment',
  },
  {
    title: 'Questionnaire',
    step: 7,
    subStep: 1,
    subStepTotal: 3,
    identifier: 'Questions',
    stage: 'Questions',
  },
  {
    title: 'Integrations',
    step: 8,
    subStep: 1,
    subStepTotal: 1,
    identifier: 'Integrations',
    stage: 'Integrations',
  },
  {
    title: 'Contract',
    step: 9,
    subStep: 1,
    subStepTotal: 2,
    identifier: 'Contract-1',
    stage: 'Contract',
  },
  {
    title: 'Contract',
    step: 9,
    subStep: 2,
    subStepTotal: 2,
    identifier: 'Contract-2',
    stage: 'Contract',
  },
];
